// extracted by mini-css-extract-plugin
export var instagramFeed = "instagramFeed-module--instagram-feed--Rf+zu";